export function FooterA() {
  return (
    <footer className="p-4 text-white text-sm">
      <div className="flex flex-col md:flex-row justify-between items-center max-w-7xl mx-auto gap-4 md:gap-0">
        <div>© {new Date().getFullYear()} Developed By SSA</div>
        <div>Financed By GCF</div>
      </div>
    </footer>
  );
}

export function FooterB() {
  return (
    <footer className="p-4 text-sm">
      <div className="flex flex-col md:flex-row justify-between items-center max-w-7xl mx-auto gap-4 md:gap-0">
        <div className="text-lime-100">
          © {new Date().getFullYear()} Developed By SSA
        </div>
        <div className="text-lime-100">Financed By GCF</div>
      </div>
    </footer>
  );
}

export default function Footer({ variant = "a" }: { variant?: "a" | "b" }) {
  return variant === "a" ? <FooterA /> : <FooterB />;
}

